import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

function VrTennis() {
    return (
        <StaticImage
            src="../../images/VrTennis.jpg"
            alt="Two hands shaking"
            placeholder="blurred"
            layout="constrained"
        />
    );
}

export default VrTennis;
